module.exports = __webpack_public_path__ + "img/vendor_logo2.852a2ef7.png";